import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalComponent {
  @Input() isOpen: boolean = false; // Controls modal visibility
  @Input() width: string = '500px'; // Customizable width
  @Input() height: string = 'auto'; // Customizable height
  @Input() showCloseIcon: boolean = true; // Option to show or hide close icon
  @Input() closeIcon: string = 'fas fa-times'; // Customizable close icon class
  @Input() customClasses: string = ''; // Additional Tailwind CSS classes for styling

  @Output() close = new EventEmitter<void>(); // Emits event when modal is closed

  closeModal() {
    this.isOpen = false;
    this.close.emit(); // Emit close event
  }

  onBackgroundClicked(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeModal(); // Close modal when background is clicked
    }
  }
}
